import { useRouteError } from 'react-router-dom';
import { useEffect } from 'react';
import { captureException } from '@/utils/sentry.utils';

export default function ErrorPage() {
  const error = useRouteError();

  useEffect(() => {
    if (error instanceof Error) {
      captureException(error);
    }
  }, [error]);

  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </div>
  );
}
